(function() {
  'use strict';

  angular
    .module('mandaeApp')
    .component('importSales', {
      template: require('./import-sales.html'),
      controller: 'ImportSalesCtrl',
    })
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('import-sales', {
          url: '/pedido/importar/:provider',
          component: 'importSales',
          authenticate: true,
        });
    }]);

}());
